function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import OnScrollTo from './OnScrollTo';

var DOMOnScrollTo =
/*#__PURE__*/
function () {
  function DOMOnScrollTo(onTrigger, render, options) {
    var _this = this;

    _classCallCheck(this, DOMOnScrollTo);

    _defineProperty(this, "retry", function () {
      return _this.onScrollTo.retry();
    });

    _defineProperty(this, "onStateChange", function (state) {
      return _this.render(state);
    });

    _defineProperty(this, "onUnmount", function () {
      _this.onScrollTo.onUnmount();
    });

    this._render = render;
    this.onScrollTo = new OnScrollTo(function () {
      return _this.element;
    }, onTrigger, this.onStateChange, options);
  }

  _createClass(DOMOnScrollTo, [{
    key: "render",
    value: function render(state) {
      this.element = this._render(state);
    }
  }, {
    key: "mount",
    value: function mount() {
      this.render(this.onScrollTo.getState());
      this.onScrollTo.onMount();
    }
  }]);

  return DOMOnScrollTo;
}();

export { DOMOnScrollTo as default };
//# sourceMappingURL=DOMOnScrollTo.js.map